function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { AspectRatio } from '@chakra-ui/react';
import React, { useImperativeHandle } from 'react';
import Panel from '../Panel';
import { WidgetEvent } from '@/types/soundcloud';
import { SongRequestProvider } from '@/types/server';
import useScript from '@/hooks/useScript';
var YOUTUBE_IFRAME_API = 'https://www.youtube.com/iframe_api';
var SOUNDCLOUD_IFRAME_API = 'https://w.soundcloud.com/player/api.js';
var YoutubePlayerEmbed = /*#__PURE__*/ React.forwardRef(function YTPlayer(param, ref) {
    var song = param.song, isPlaying = param.isPlaying, panelProps = param.panelProps, volume = param.volume, onPause = param.onPause, onPlay = param.onPlay, onBuffer = param.onBuffer, onBufferEnd = param.onBufferEnd, onEnded = param.onEnded, onDuration = param.onDuration, onError = param.onError, onSeek = param.onSeek, onVolume = param.onVolume;
    var positionRef = React.useRef(0);
    var iframeRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(null), 2), player = _React_useState[0], setPlayer = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(window.YT), 2), YT = _React_useState1[0], setYT = _React_useState1[1];
    var onStateChangeRef = React.useRef(null);
    var onErrorRef = React.useRef(undefined);
    var onStateChange = React.useCallback(function(event) {
        if (YT == null) {
            return;
        }
        var position = event.target.getCurrentTime();
        var duration = event.target.getDuration();
        // YouTube doesn't have a seek event, so we need to check if the position has changed
        if (Math.abs(position - positionRef.current) > 1) {
            positionRef.current = position;
            onSeek === null || onSeek === void 0 ? void 0 : onSeek(position);
        }
        if (event.data === YT.PlayerState.PLAYING) {
            onBufferEnd === null || onBufferEnd === void 0 ? void 0 : onBufferEnd();
            onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        } else if (event.data === YT.PlayerState.PAUSED && position > 0) {
            onPause === null || onPause === void 0 ? void 0 : onPause();
        } else if (event.data === YT.PlayerState.ENDED) {
            onEnded === null || onEnded === void 0 ? void 0 : onEnded();
        } else if (event.data === YT.PlayerState.BUFFERING) {
            onBuffer === null || onBuffer === void 0 ? void 0 : onBuffer();
        } else if (event.data === YT.PlayerState.UNSTARTED) {
            event.target.setVolume(volume);
        }
        onDuration === null || onDuration === void 0 ? void 0 : onDuration(duration);
    }, [
        YT,
        positionRef,
        onSeek,
        onPlay,
        onPause,
        onEnded,
        onBuffer,
        onBufferEnd,
        onDuration,
        volume
    ]);
    React.useEffect(function() {
        if (YT == null || player == null) {
            return;
        }
        var interval = setInterval(function() {
            var newVolume = player.getVolume();
            if (player.getPlayerState() === YT.PlayerState.PLAYING && volume !== newVolume) {
                onVolume === null || onVolume === void 0 ? void 0 : onVolume(newVolume);
            }
        }, 100);
        return function() {
            return clearInterval(interval);
        };
    }, [
        YT,
        player,
        volume,
        onVolume
    ]);
    React.useEffect(function() {
        onStateChangeRef.current = onStateChange;
    }, [
        onStateChangeRef,
        onStateChange
    ]);
    React.useEffect(function() {
        onErrorRef.current = onError;
    }, [
        onErrorRef,
        onError
    ]);
    React.useEffect(function() {
        if (player == null || song.track.providerId == null) {
            return;
        }
        player.pauseVideo();
        player.seekTo(0, true);
        if (isPlaying) {
            player.loadVideoById(song.track.providerId);
        } else {
            player.cueVideoById(song.track.providerId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        song.track.providerId
    ]);
    React.useEffect(function() {
        if (YT == null || iframeRef.current == null) {
            return;
        }
        var currentPlayer = new YT.Player(iframeRef.current, {
            height: '100%',
            width: '100%',
            videoId: song.track.providerId,
            events: {
                onStateChange: function(event) {
                    var _onStateChangeRef_current;
                    return (_onStateChangeRef_current = onStateChangeRef.current) === null || _onStateChangeRef_current === void 0 ? void 0 : _onStateChangeRef_current.call(onStateChangeRef, event);
                },
                onError: function(event) {
                    var _onErrorRef_current;
                    return (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, event);
                },
                onReady: function() {
                    return setPlayer(currentPlayer);
                }
            },
            playerVars: {
                autoplay: isPlaying ? 1 : 0,
                fs: 0,
                rel: 0,
                controls: 2,
                disablekb: 1,
                showinfo: 0,
                cc_load_policy: 0,
                iv_load_policy: 3
            }
        });
        return function() {
            return currentPlayer.destroy();
        };
    // song and isPlaying are initial iframe load dependencies
    // and the effect above controls playback
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        YT,
        iframeRef,
        onStateChangeRef,
        onErrorRef
    ]);
    useScript({
        src: YOUTUBE_IFRAME_API,
        onBeforeLoad: function() {
            window.onYouTubeIframeAPIReady = function() {
                setYT(window.YT);
                delete window.onYouTubeIframeAPIReady;
            };
        }
    });
    var seekPlayer = React.useCallback(function(position) {
        if (player == null) {
            return;
        }
        player.seekTo(position, true);
    }, [
        player
    ]);
    var playerVolume = React.useCallback(function(volume) {
        if (player == null) {
            return;
        }
        player.setVolume(volume);
    }, [
        player
    ]);
    var playPlayer = React.useCallback(function() {
        if (player == null) {
            return;
        }
        player.playVideo();
    }, [
        player
    ]);
    var pausePlayer = React.useCallback(function() {
        if (player == null) {
            return;
        }
        player.pauseVideo();
    }, [
        player
    ]);
    useImperativeHandle(ref, function() {
        return {
            seek: seekPlayer,
            volume: playerVolume,
            play: playPlayer,
            pause: pausePlayer
        };
    });
    return /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
        as: AspectRatio,
        ratio: 16 / 9
    }, panelProps), {
        children: /*#__PURE__*/ _jsx("div", {
            ref: iframeRef
        })
    }));
});
var SoundcloudPlayerEmbed = /*#__PURE__*/ React.forwardRef(function SoundcloudPlayer(param, ref) {
    var song = param.song, isPlaying = param.isPlaying, volume = param.volume, panelProps = param.panelProps, onPause = param.onPause, onPlay = param.onPlay, onEnded = param.onEnded, onDuration = param.onDuration, onError = param.onError, onSeek = param.onSeek;
    var iframeRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(), 2), SC = _React_useState[0], setSC = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(), 2), player = _React_useState1[0], setPlayer = _React_useState1[1];
    var volumeRef = React.useRef(volume);
    var _React_useState2 = _sliced_to_array(React.useState(song.track.url), 1), initialSongTrackUrl = _React_useState2[0];
    useScript({
        src: SOUNDCLOUD_IFRAME_API,
        onLoad: function() {
            return setSC(window.SC);
        }
    });
    React.useEffect(function() {
        volumeRef.current = volume;
    }, [
        volume
    ]);
    React.useEffect(function() {
        if (SC == null || iframeRef.current == null) {
            return;
        }
        setPlayer(SC.Widget(iframeRef.current));
    }, [
        SC,
        iframeRef
    ]);
    React.useEffect(function() {
        if (player == null) {
            return;
        }
        player.bind(WidgetEvent.PLAY, function() {
            return onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        });
        player.bind(WidgetEvent.FINISH, function() {
            return onEnded === null || onEnded === void 0 ? void 0 : onEnded();
        });
        player.bind(WidgetEvent.ERROR, function(event) {
            return onError === null || onError === void 0 ? void 0 : onError(event);
        });
        player.bind(WidgetEvent.SEEK, function(param) {
            var currentPosition = param.currentPosition;
            return onSeek === null || onSeek === void 0 ? void 0 : onSeek(currentPosition / 1000);
        });
        // <= 0.99 as on pause will be called with on finish, breaking auto-play
        player.bind(WidgetEvent.PAUSE, function(param) {
            var relativePosition = param.relativePosition;
            return relativePosition > 0 && relativePosition <= 0.99 && (onPause === null || onPause === void 0 ? void 0 : onPause());
        });
        return function() {
            try {
                player.unbind(WidgetEvent.PLAY);
                player.unbind(WidgetEvent.FINISH);
                player.unbind(WidgetEvent.ERROR);
                player.unbind(WidgetEvent.SEEK);
                player.unbind(WidgetEvent.PAUSE);
            } catch (_) {}
        };
    }, [
        player,
        onPlay,
        onEnded,
        onError,
        onSeek,
        onPause
    ]);
    React.useEffect(function() {
        if (player == null || song.track.url == null) {
            return;
        }
        player.setVolume(volumeRef.current);
        player.load(song.track.url, {
            auto_play: isPlaying !== null && isPlaying !== void 0 ? isPlaying : false,
            show_artwork: true,
            buying: false,
            liking: false,
            sharing: false,
            download: false,
            show_playcount: false,
            show_comments: false,
            show_user: false,
            visual: true,
            hide_related: true,
            // READY event is only called on initial player load, and there's no other load event
            callback: function() {
                player.getDuration(function(duration) {
                    return onDuration === null || onDuration === void 0 ? void 0 : onDuration(duration / 1000);
                });
                player.setVolume(volumeRef.current);
            }
        });
    // isPlaying, onDuration are initial load dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        player,
        song.track.url
    ]);
    var seekPlayer = React.useCallback(function(position) {
        if (player == null) {
            return;
        }
        player.seekTo(position * 1000);
    }, [
        player
    ]);
    var playerVolume = React.useCallback(function(volume) {
        if (player == null) {
            return;
        }
        player.setVolume(volume);
    }, [
        player
    ]);
    var playPlayer = React.useCallback(function() {
        if (player == null) {
            return;
        }
        player.play();
    }, [
        player
    ]);
    var pausePlayer = React.useCallback(function() {
        if (player == null) {
            return;
        }
        player.pause();
    }, [
        player
    ]);
    useImperativeHandle(ref, function() {
        return {
            seek: seekPlayer,
            volume: playerVolume,
            play: playPlayer,
            pause: pausePlayer
        };
    });
    return /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
        as: AspectRatio,
        ratio: 1
    }, panelProps), {
        children: /*#__PURE__*/ _jsx("iframe", {
            ref: iframeRef,
            src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(initialSongTrackUrl), "&autoplay=false"),
            allow: "autoplay"
        })
    }));
});
export default /*#__PURE__*/ React.forwardRef(function EmbedForwardRef(props, ref) {
    if (props.song == null || typeof props.song.track.url !== 'string') {
        return null;
    }
    if (props.song.track.provider === SongRequestProvider.YOUTUBE) {
        return /*#__PURE__*/ _jsx(YoutubePlayerEmbed, _object_spread({
            ref: ref
        }, props));
    }
    if (props.song.track.provider === SongRequestProvider.SOUNDCLOUD) {
        return /*#__PURE__*/ _jsx(SoundcloudPlayerEmbed, _object_spread({
            ref: ref
        }, props));
    }
    throw new Error('Unsupported media source');
});
